"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionBtnByRouter = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取角色当前页面的按钮
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getOptionBtnByRouter = exports.getOptionBtnByRouter = function getOptionBtnByRouter(data) {
  return _api.default.request({
    url: '/roleMenu/getOptionBtnByRouter',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};